import { Injectable } from '@angular/core';

/**
 * Service pour passer les données de conversion (Convertir → formulaire document) entre le modal et le DocumentComponent.
 * Utilisé car le state de navigation (router state) peut être perdu après la navigation.
 */
@Injectable({
  providedIn: 'root'
})
export class ConversionStateService {
  private conversionFrom: any = null;

  set(data: any): void {
    this.conversionFrom = data;
  }

  get(): any {
    return this.conversionFrom;
  }

  consume(): any {
    const data = this.conversionFrom;
    this.conversionFrom = null;
    return data;
  }

  clear(): void {
    this.conversionFrom = null;
  }
}
